import type { IconName } from "../components/icon/Icon";

export type SelectableIconName = IconName &
  (
    | "academicCap"
    | "adjustments"
    | "archive"
    | "arrowCircleDown"
    | "arrowCircleLeft"
    | "arrowCircleRight"
    | "arrowCircleUp"
    | "arrowDown"
    | "arrowLeft"
    | "arrowRight"
    | "arrowsExpand"
    | "arrowUp"
    | "atSymbol"
    | "backspace"
    | "beaker"
    | "bell"
    | "bookmark"
    | "bookmarkAlt"
    | "bookOpen"
    | "briefcase"
    | "calculator"
    | "calendar"
    | "camera"
    | "car"
    | "cash"
    | "chartBar"
    | "chartPie"
    | "chat"
    | "chatAlt"
    | "chatAlt_2"
    | "check"
    | "checkCircle"
    | "chevronDown"
    | "chevronLeft"
    | "chevronRight"
    | "chevronUp"
    | "clipboard"
    | "clock"
    | "cloud"
    | "cloudDownload"
    | "cloudUpload"
    | "code"
    | "cog"
    | "collection"
    | "creditCard"
    | "cube"
    | "currencyDollar"
    | "currencyEuro"
    | "currencyYen"
    | "desktopComputer"
    | "deviceMobile"
    | "deviceTablet"
    | "document"
    | "documentDuplicate"
    | "documentText"
    | "dotsHorizontal"
    | "dotsVertical"
    | "download"
    | "duplicate"
    | "emojiHappy"
    | "emojiSad"
    | "exclamation"
    | "exclamationCircle"
    | "eye"
    | "eyeOff"
    | "film"
    | "filter"
    | "fire"
    | "flag"
    | "folder"
    | "globe"
    | "hand"
    | "hashtag"
    | "heart"
    | "home"
    | "inbox"
    | "inboxIn"
    | "informationCircle"
    | "key"
    | "lightBulb"
    | "lightningBolt"
    | "link"
    | "locationMarker"
    | "lockClosed"
    | "lockOpen"
    | "login"
    | "logout"
    | "mail"
    | "mailOpen"
    | "map"
    | "menu"
    | "microphone"
    | "minus"
    | "minusCircle"
    | "moon"
    | "musicNote"
    | "paperAirplane"
    | "paperClip"
    | "pause"
    | "pencil"
    | "pencilAlt"
    | "phone"
    | "photograph"
    | "play"
    | "plus"
    | "plusCircle"
    | "printer"
    | "qrcode"
    | "questionMarkCircle"
    | "refresh"
    | "reply"
    | "rss"
    | "scissors"
    | "search"
    | "share"
    | "shoppingBag"
    | "shoppingCart"
    | "speakerphone"
    | "star"
    | "statusOnline"
    | "stop"
    | "sun"
    | "support"
    | "switchHorizontal"
    | "tag"
    | "thumbDown"
    | "thumbUp"
    | "trash"
    | "trendingDown"
    | "trendingUp"
    | "upload"
    | "user"
    | "userAdd"
    | "userGroup"
    | "users"
    | "videoCamera"
    | "viewGrid"
    | "viewList"
    | "volumeOff"
    | "volumeUp"
    | "wifi"
    | "x"
    | "xCircle"
  );

const fromLegacyMapping: Record<string, SelectableIconName> = {
  ionic: "stop",
  "arrow-up-a": "arrowUp",
  "arrow-right-a": "arrowRight",
  "arrow-down-a": "arrowDown",
  "arrow-left-a": "arrowLeft",
  "arrow-up-b": "chevronUp",
  "arrow-right-b": "chevronRight",
  "arrow-down-b": "chevronDown",
  "arrow-left-b": "chevronLeft",
  "arrow-up-c": "arrowUp",
  "arrow-right-c": "arrowRight",
  "arrow-down-c": "arrowDown",
  "arrow-left-c": "arrowLeft",
  "arrow-swap": "switchHorizontal",
  "arrow-expand": "arrowsExpand",
  "chevron-up": "chevronUp",
  "chevron-right": "chevronRight",
  "chevron-down": "chevronDown",
  "chevron-left": "chevronLeft",
  "nav-round": "menu",
  nav: "menu",
  drag: "menu",
  "log-in": "login",
  "log-out": "logout",
  "checkmark-round": "check",
  checkmark: "check",
  "checkmark-circled": "checkCircle",
  "close-round": "x",
  close: "x",
  "close-circled": "xCircle",
  "plus-round": "plus",
  plus: "plus",
  "plus-circled": "plusCircle",
  "minus-round": "minus",
  minus: "minus",
  "minus-circled": "minusCircle",
  information: "informationCircle",
  "information-circled": "informationCircle",
  help: "questionMarkCircle",
  "help-circled": "questionMarkCircle",
  "backspace-outline": "backspace",
  backspace: "backspace",
  "help-buoy": "support",
  alert: "exclamation",
  "alert-circled": "exclamationCircle",
  refresh: "refresh",
  loop: "refresh",
  home: "home",
  search: "search",
  flag: "flag",
  star: "star",
  heart: "heart",
  "gear-a": "cog",
  "gear-b": "cog",
  settings: "cog",
  edit: "pencil",
  "trash-a": "trash",
  "trash-b": "trash",
  document: "document",
  "document-text": "documentText",
  clipboard: "clipboard",
  scissors: "scissors",
  funnel: "filter",
  bookmark: "bookmark",
  email: "mail",
  "email-unread": "mail",
  folder: "folder",
  filing: "collection",
  archive: "inboxIn",
  reply: "reply",
  "reply-all": "reply",
  share: "share",
  "paper-airplane": "paperAirplane",
  link: "link",
  paperclip: "paperClip",
  compose: "pencilAlt",
  briefcase: "briefcase",
  at: "atSymbol",
  pound: "hashtag",
  cloud: "cloud",
  upload: "cloudUpload",
  more: "dotsHorizontal",
  grid: "viewGrid",
  calendar: "calendar",
  clock: "clock",
  navigate: "paperAirplane",
  location: "locationMarker",
  map: "map",
  "lock-combination": "lockClosed",
  locked: "lockClosed",
  unlocked: "lockOpen",
  key: "key",
  "arrow-graph-up-right": "trendingUp",
  "arrow-graph-down-right": "trendingDown",
  "stats-bars": "chartBar",
  "pie-graph": "chartPie",
  chatbubble: "chat",
  "chatbubble-working": "chat",
  chatbubbles: "chatAlt_2",
  chatbox: "chatAlt",
  "chatbox-working": "chatAlt",
  chatboxes: "chatAlt_2",
  person: "user",
  "person-add": "userAdd",
  "person-stalker": "users",
  wifi: "wifi",
  calculator: "calculator",
  camera: "camera",
  eye: "eye",
  "eye-disabled": "eyeOff",
  flash: "lightningBolt",
  "qr-scanner": "qrcode",
  image: "photograph",
  images: "photograph",
  monitor: "desktopComputer",
  laptop: "desktopComputer",
  ipad: "deviceTablet",
  iphone: "deviceMobile",
  ipod: "deviceMobile",
  printer: "printer",
  code: "code",
  "code-working": "code",
  "code-download": "code",
  videocamera: "videoCamera",
  "music-note": "musicNote",
  "radio-waves": "statusOnline",
  speakerphone: "speakerphone",
  "mic-a": "microphone",
  "mic-b": "microphone",
  "mic-c": "microphone",
  "volume-high": "volumeUp",
  "volume-medium": "volumeUp",
  "volume-low": "volumeUp",
  "volume-mute": "volumeOff",
  levels: "adjustments",
  play: "play",
  pause: "pause",
  stop: "stop",
  bag: "shoppingBag",
  card: "creditCard",
  cash: "cash",
  pricetag: "tag",
  pricetags: "tag",
  thumbsup: "thumbUp",
  thumbsdown: "thumbDown",
  "happy-outline": "emojiHappy",
  happy: "emojiHappy",
  "sad-outline": "emojiSad",
  sad: "emojiSad",
  podium: "chartBar",
  university: "academicCap",
  beaker: "beaker",
  "erlenmeyer-flask": "beaker",
  earth: "globe",
  planet: "globe",
  lightbulb: "lightBulb",
  cube: "cube",
  flame: "fire",
  fireball: "fire",
  bonfire: "fire",
  "model-s": "car",
  plane: "paperAirplane",
  jet: "paperAirplane",
  "ios-ionic-outline": "stop",
  "ios-arrow-back": "chevronLeft",
  "ios-arrow-forward": "chevronRight",
  "ios-arrow-up": "chevronUp",
  "ios-arrow-right": "chevronRight",
  "ios-arrow-down": "chevronDown",
  "ios-arrow-left": "chevronLeft",
  "ios-arrow-thin-up": "arrowUp",
  "ios-arrow-thin-right": "arrowRight",
  "ios-arrow-thin-down": "arrowDown",
  "ios-arrow-thin-left": "arrowLeft",
  "ios-checkmark-empty": "check",
  "ios-checkmark-outline": "checkCircle",
  "ios-checkmark": "checkCircle",
  "ios-plus-empty": "plus",
  "ios-plus-outline": "plusCircle",
  "ios-plus": "plusCircle",
  "ios-close-empty": "x",
  "ios-close-outline": "xCircle",
  "ios-close": "xCircle",
  "ios-minus-empty": "minus",
  "ios-minus-outline": "minusCircle",
  "ios-minus": "minusCircle",
  "ios-information-empty": "informationCircle",
  "ios-information-outline": "informationCircle",
  "ios-information": "informationCircle",
  "ios-help-empty": "questionMarkCircle",
  "ios-help-outline": "questionMarkCircle",
  "ios-help": "questionMarkCircle",
  "ios-search": "search",
  "ios-search-strong": "search",
  "ios-star": "star",
  "ios-star-half": "star",
  "ios-star-outline": "star",
  "ios-heart": "heart",
  "ios-heart-outline": "heart",
  "ios-more": "dotsHorizontal",
  "ios-more-outline": "dotsHorizontal",
  "ios-home": "home",
  "ios-home-outline": "home",
  "ios-cloud": "cloud",
  "ios-cloud-outline": "cloud",
  "ios-cloud-upload": "cloudUpload",
  "ios-cloud-upload-outline": "cloudUpload",
  "ios-cloud-download": "cloudDownload",
  "ios-cloud-download-outline": "cloudDownload",
  "ios-upload": "upload",
  "ios-upload-outline": "upload",
  "ios-download": "download",
  "ios-download-outline": "download",
  "ios-refresh": "refresh",
  "ios-refresh-outline": "refresh",
  "ios-refresh-empty": "refresh",
  "ios-reload": "refresh",
  "ios-loop-strong": "refresh",
  "ios-loop": "refresh",
  "ios-bookmarks": "bookmarkAlt",
  "ios-bookmarks-outline": "bookmarkAlt",
  "ios-book": "bookOpen",
  "ios-book-outline": "bookOpen",
  "ios-flag": "flag",
  "ios-flag-outline": "flag",
  "ios-browsers": "duplicate",
  "ios-browsers-outline": "duplicate",
  "ios-at": "atSymbol",
  "ios-at-outline": "atSymbol",
  "ios-pricetag": "tag",
  "ios-pricetag-outline": "tag",
  "ios-pricetags": "tag",
  "ios-pricetags-outline": "tag",
  "ios-cart": "shoppingCart",
  "ios-cart-outline": "shoppingCart",
  "ios-chatboxes": "chatAlt_2",
  "ios-chatboxes-outline": "chatAlt_2",
  "ios-chatbubble": "chat",
  "ios-chatbubble-outline": "chat",
  "ios-cog": "cog",
  "ios-cog-outline": "cog",
  "ios-gear": "cog",
  "ios-gear-outline": "cog",
  "ios-settings": "adjustments",
  "ios-settings-strong": "adjustments",
  "ios-filing": "inbox",
  "ios-filing-outline": "inbox",
  "ios-box": "archive",
  "ios-box-outline": "archive",
  "ios-compose": "pencilAlt",
  "ios-compose-outline": "pencilAlt",
  "ios-trash": "trash",
  "ios-trash-outline": "trash",
  "ios-copy": "documentDuplicate",
  "ios-copy-outline": "documentDuplicate",
  "ios-email": "mail",
  "ios-email-outline": "mail",
  "ios-undo": "reply",
  "ios-undo-outline": "reply",
  "ios-paperplane": "paperAirplane",
  "ios-paperplane-outline": "paperAirplane",
  "ios-folder": "folder",
  "ios-folder-outline": "folder",
  "ios-paper": "document",
  "ios-paper-outline": "document",
  "ios-list": "viewList",
  "ios-list-outline": "viewList",
  "ios-world": "globe",
  "ios-world-outline": "globe",
  "ios-alarm": "clock",
  "ios-alarm-outline": "clock",
  "ios-stopwatch": "clock",
  "ios-stopwatch-outline": "clock",
  "ios-timer": "clock",
  "ios-timer-outline": "clock",
  "ios-clock": "clock",
  "ios-clock-outline": "clock",
  "ios-time": "clock",
  "ios-time-outline": "clock",
  "ios-calendar": "calendar",
  "ios-calendar-outline": "calendar",
  "ios-photos": "duplicate",
  "ios-photos-outline": "duplicate",
  "ios-albums": "duplicate",
  "ios-albums-outline": "duplicate",
  "ios-camera": "camera",
  "ios-camera-outline": "camera",
  "ios-eye": "eye",
  "ios-eye-outline": "eye",
  "ios-bolt": "lightningBolt",
  "ios-bolt-outline": "lightningBolt",
  "ios-grid-view": "viewGrid",
  "ios-grid-view-outline": "viewGrid",
  "ios-barcode": "qrcode",
  "ios-barcode-outline": "qrcode",
  "ios-briefcase": "briefcase",
  "ios-briefcase-outline": "briefcase",
  "ios-calculator": "calculator",
  "ios-calculator-outline": "calculator",
  "ios-keypad": "viewGrid",
  "ios-keypad-outline": "viewGrid",
  "ios-telephone": "phone",
  "ios-telephone-outline": "phone",
  "ios-location": "locationMarker",
  "ios-locatoutline": "locationMarker",
  "ios-navigate": "paperAirplane",
  "ios-navigate-outline": "paperAirplane",
  "ios-locked": "lockClosed",
  "ios-locked-outline": "lockClosed",
  "ios-unlocked": "lockOpen",
  "ios-unlocked-outline": "lockOpen",
  "ios-monitor": "desktopComputer",
  "ios-monitor-outline": "desktopComputer",
  "ios-printer": "printer",
  "ios-printer-outline": "printer",
  "ios-person": "user",
  "ios-person-outline": "user",
  "ios-personadd": "userAdd",
  "ios-personadd-outline": "userAdd",
  "ios-people": "userGroup",
  "ios-people-outline": "userGroup",
  "ios-musical-notes": "musicNote",
  "ios-musical-note": "musicNote",
  "ios-bell": "bell",
  "ios-bell-outline": "bell",
  "ios-mic": "microphone",
  "ios-mic-outline": "microphone",
  "ios-volume-high": "volumeUp",
  "ios-volume-low": "volumeOff",
  "ios-play": "play",
  "ios-play-outline": "play",
  "ios-pause": "pause",
  "ios-pause-outline": "pause",
  "ios-videocam": "videoCamera",
  "ios-videocam-outline": "videoCamera",
  "ios-film": "film",
  "ios-film-outline": "film",
  "ios-flask": "beaker",
  "ios-flask-outline": "beaker",
  "ios-lightbulb": "lightBulb",
  "ios-lightbulb-outline": "lightBulb",
  "ios-flame": "fire",
  "ios-flame-outline": "fire",
  "ios-sunny": "sun",
  "ios-sunny-outline": "sun",
  "ios-moon": "moon",
  "ios-moon-outline": "moon",
  "android-arrow-up": "arrowUp",
  "android-arrow-forward": "arrowRight",
  "android-arrow-down": "arrowDown",
  "android-arrow-back": "arrowLeft",
  "android-arrow-dropup": "chevronUp",
  "android-arrow-dropup-circle": "arrowCircleUp",
  "android-arrow-dropright": "chevronRight",
  "android-arrow-dropright-circle": "arrowCircleRight",
  "android-arrow-dropdown": "chevronDown",
  "android-arrow-dropdown-circle": "arrowCircleDown",
  "android-arrow-dropleft": "chevronLeft",
  "android-arrow-dropleft-circle": "arrowCircleLeft",
  "android-add": "plus",
  "android-add-circle": "plusCircle",
  "android-remove": "minus",
  "android-remove-circle": "minusCircle",
  "android-close": "x",
  "android-cancel": "xCircle",
  "android-checkmark-circle": "checkCircle",
  "android-done": "check",
  "android-done-all": "check",
  "android-menu": "menu",
  "android-more-horizontal": "dotsHorizontal",
  "android-more-vertical": "dotsVertical",
  "android-refresh": "refresh",
  "android-sync": "refresh",
  "android-wifi": "wifi",
  "android-call": "phone",
  "android-apps": "viewGrid",
  "android-settings": "cog",
  "android-options": "adjustments",
  "android-funnel": "filter",
  "android-search": "search",
  "android-home": "home",
  "android-cloud-outline": "cloud",
  "android-cloud": "cloud",
  "android-download": "cloudDownload",
  "android-upload": "cloudUpload",
  "android-cloud-done": "cloud",
  "android-cloud-circle": "cloud",
  "android-favorite-outline": "heart",
  "android-favorite": "heart",
  "android-star-outline": "star",
  "android-star-half": "star",
  "android-star": "star",
  "android-calendar": "calendar",
  "android-alarm-clock": "clock",
  "android-time": "clock",
  "android-stopwatch": "clock",
  "android-navigate": "paperAirplane",
  "android-pin": "locationMarker",
  "android-map": "map",
  "android-car": "car",
  "android-bus": "car",
  "android-train": "car",
  "android-plane": "paperAirplane",
  "android-cart": "shoppingCart",
  "android-camera": "camera",
  "android-image": "photograph",
  "android-create": "pencil",
  "android-mail": "mail",
  "android-drafts": "mailOpen",
  "android-send": "paperAirplane",
  "android-archive": "inboxIn",
  "android-delete": "trash",
  "android-attach": "paperClip",
  "android-share": "share",
  "android-share-alt": "share",
  "android-bookmark": "bookmark",
  "android-document": "document",
  "android-clipboard": "clipboard",
  "android-list": "viewList",
  "android-folder-open": "folder",
  "android-folder": "folder",
  "android-print": "printer",
  "android-open": "login",
  "android-exit": "logout",
  "android-expand": "arrowsExpand",
  "android-globe": "globe",
  "android-chat": "chatAlt_2",
  "android-textsms": "chatAlt",
  "android-happy": "emojiHappy",
  "android-sad": "emojiSad",
  "android-person": "user",
  "android-people": "users",
  "android-person-add": "userAdd",
  "android-contact": "user",
  "android-contacts": "users",
  "android-lock": "lockClosed",
  "android-unlock": "lockOpen",
  "android-microphone": "microphone",
  "android-notifications-none": "bell",
  "android-notifications": "bell",
  "android-volume-mute": "volumeOff",
  "android-volume-down": "volumeUp",
  "android-volume-up": "volumeUp",
  "android-volume-off": "volumeOff",
  "android-hand": "hand",
  "android-desktop": "desktopComputer",
  "android-laptop": "desktopComputer",
  "android-phone-portrait": "deviceMobile",
  "android-phone-landscape": "deviceMobile",
  "android-bulb": "lightBulb",
  "android-sunny": "sun",
  "android-alert": "exclamationCircle",
  "android-warning": "exclamation",
  "social-rss": "rss",
  "social-rss-outline": "rss",
  "social-usd": "currencyDollar",
  "social-usd-outline": "currencyDollar",
  "social-yen": "currencyYen",
  "social-yen-outline": "currencyYen",
  "social-euro": "currencyEuro",
  "social-euro-outline": "currencyEuro",
};

const toLegacyMapping: Record<SelectableIconName, string> = {
  academicCap: "university",
  adjustments: "levels",
  archive: "ios-box",
  arrowCircleDown: "android-arrow-dropdown-circle",
  arrowCircleLeft: "android-arrow-dropleft-circle",
  arrowCircleRight: "android-arrow-dropright-circle",
  arrowCircleUp: "android-arrow-dropup-circle",
  arrowDown: "arrow-down-a",
  arrowLeft: "arrow-left-a",
  arrowRight: "arrow-right-a",
  arrowUp: "arrow-up-a",
  arrowsExpand: "arrow-expand",
  atSymbol: "at",
  backspace: "backspace-outline",
  beaker: "beaker",
  bell: "ios-bell",
  bookOpen: "ios-book",
  bookmark: "bookmark",
  bookmarkAlt: "ios-bookmarks",
  briefcase: "briefcase",
  calculator: "calculator",
  calendar: "calendar",
  camera: "camera",
  car: "model-s",
  cash: "cash",
  chartBar: "stats-bars",
  chartPie: "pie-graph",
  chat: "chatbubble",
  chatAlt: "chatbox",
  chatAlt_2: "chatbubbles",
  check: "checkmark-round",
  checkCircle: "checkmark-circled",
  chevronDown: "arrow-down-b",
  chevronLeft: "arrow-left-b",
  chevronRight: "arrow-right-b",
  chevronUp: "arrow-up-b",
  clipboard: "clipboard",
  clock: "clock",
  cloud: "cloud",
  cloudDownload: "ios-cloud-download",
  cloudUpload: "upload",
  code: "code",
  cog: "gear-a",
  collection: "filing",
  creditCard: "card",
  cube: "cube",
  currencyDollar: "social-usd",
  currencyEuro: "social-euro",
  currencyYen: "social-yen",
  desktopComputer: "monitor",
  deviceMobile: "iphone",
  deviceTablet: "ipad",
  document: "document",
  documentDuplicate: "ios-copy",
  documentText: "document-text",
  dotsHorizontal: "more",
  dotsVertical: "android-more-vertical",
  download: "ios-download",
  duplicate: "ios-browsers",
  emojiHappy: "happy-outline",
  emojiSad: "sad-outline",
  exclamation: "alert",
  exclamationCircle: "alert-circled",
  eye: "eye",
  eyeOff: "eye-disabled",
  film: "ios-film",
  filter: "funnel",
  fire: "flame",
  flag: "flag",
  folder: "folder",
  globe: "earth",
  hand: "android-hand",
  hashtag: "pound",
  heart: "heart",
  home: "home",
  inbox: "ios-filing",
  inboxIn: "archive",
  informationCircle: "information",
  key: "key",
  lightBulb: "lightbulb",
  lightningBolt: "flash",
  link: "link",
  locationMarker: "location",
  lockClosed: "lock-combination",
  lockOpen: "unlocked",
  login: "log-in",
  logout: "log-out",
  mail: "email",
  mailOpen: "android-drafts",
  map: "map",
  menu: "nav-round",
  microphone: "mic-a",
  minus: "minus-round",
  minusCircle: "minus-circled",
  moon: "ios-moon",
  musicNote: "music-note",
  paperAirplane: "paper-airplane",
  paperClip: "paperclip",
  pause: "pause",
  pencil: "edit",
  pencilAlt: "compose",
  phone: "ios-telephone",
  photograph: "image",
  play: "play",
  plus: "plus-round",
  plusCircle: "plus-circled",
  printer: "printer",
  qrcode: "qr-scanner",
  questionMarkCircle: "help",
  refresh: "refresh",
  reply: "reply",
  rss: "social-rss",
  scissors: "scissors",
  search: "search",
  share: "share",
  shoppingBag: "bag",
  shoppingCart: "ios-cart",
  speakerphone: "speakerphone",
  star: "star",
  statusOnline: "radio-waves",
  stop: "ionic",
  sun: "ios-sunny",
  support: "help-buoy",
  switchHorizontal: "arrow-swap",
  tag: "pricetag",
  thumbDown: "thumbsdown",
  thumbUp: "thumbsup",
  trash: "trash-a",
  trendingDown: "arrow-graph-down-right",
  trendingUp: "arrow-graph-up-right",
  upload: "ios-upload",
  user: "person",
  userAdd: "person-add",
  userGroup: "ios-people",
  users: "person-stalker",
  videoCamera: "videocamera",
  viewGrid: "grid",
  viewList: "ios-list",
  volumeOff: "volume-mute",
  volumeUp: "volume-high",
  wifi: "wifi",
  x: "close-round",
  xCircle: "close-circled",
};

export const fromLegacyPlatformIcon = (key: string, fallback: IconName): SelectableIconName =>
  fromLegacyMapping[key] || fallback;

export const toLegacyPlatformIcon = (key: SelectableIconName): string => toLegacyMapping[key];
